<template>
  <div class="forgetpassword-page">
    <div class="forgetpassword-page-inner">
      <div class="forgetpassword-page-box" v-if="inputtype">
        <h1>{{ $t('forgetpassword.t1') }}</h1>
        <p>{{ $t('forgetpassword.t2') }}</p>
        <p>{{ $t('forgetpassword.t21') }}</p>
        <div class="forgetpassword-page-form">
          <el-input v-model="email" :placeholder=" $t('forgetpassword.t3') "></el-input>
          <el-button @click="forgetpasswordSubmit">{{ $t('forgetpassword.t4') }}</el-button>
        </div>
      </div>
      <div class="forgetpassword-page-box" v-if="confirmtype">
        <h1>{{ $t('forgetpassword.t1') }}</h1>
        <div class="forgetpassword-confirmed">
          <p>{{ $t('forgetpassword.t5') }}</p>
          <router-link to="/Login">{{ $t('forgetpassword.t6') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      'email': '',
      'inputtype': true,
      'confirmtype': false
    }
  },
  methods:{
    forgetpasswordSubmit: function(){
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/forgetpassword';
      let dataLogin = {
        account: that.email,
      }
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(dataLogin),
        contentType: "application/json",
        success: function(data) {
          console.log('success', data)
          that.inputtype = false
          that.confirmtype = true
        },
        error: function(response) {
          console.log('error', response)
        }
      })      
    }
  }
}
</script>